import dayjs from "dayjs";

export const DASHBOARD_CHART_GRANULARITY = Object.freeze({
  DAY: "day",
  WEEK: "week",
  MONTH: "month",
});

export const resolveDashboardChartGranularity = (startDate, endDate) => {
  const start = dayjs(startDate);
  const end = dayjs(endDate);
  if (!start.isValid() || !end.isValid()) {
    return DASHBOARD_CHART_GRANULARITY.DAY;
  }

  const days = end.startOf("day").diff(start.startOf("day"), "day") + 1;
  if (days <= 31) return DASHBOARD_CHART_GRANULARITY.DAY;
  if (days <= 183) return DASHBOARD_CHART_GRANULARITY.WEEK;
  return DASHBOARD_CHART_GRANULARITY.MONTH;
};

const getBucketKey = (value, granularity) => {
  const date = dayjs(value);
  if (!date.isValid()) return null;
  if (granularity === DASHBOARD_CHART_GRANULARITY.MONTH) {
    return date.startOf("month").format("YYYY-MM-DD");
  }
  if (granularity === DASHBOARD_CHART_GRANULARITY.WEEK) {
    const mondayOffset = (date.day() + 6) % 7;
    return date.subtract(mondayOffset, "day").startOf("day").format("YYYY-MM-DD");
  }
  return date.format("YYYY-MM-DD");
};

export const aggregateDashboardChart = (
  chartData,
  valueFields,
  granularity,
) => {
  if (!chartData?.labels || !Array.isArray(chartData.labels)) return null;
  if (granularity === DASHBOARD_CHART_GRANULARITY.DAY) {
    return { ...chartData, granularity };
  }

  const buckets = new Map();
  chartData.labels.forEach((label, index) => {
    const bucketKey = getBucketKey(label, granularity);
    if (!bucketKey) return;
    if (!buckets.has(bucketKey)) {
      buckets.set(
        bucketKey,
        valueFields.reduce((entry, field) => ({ ...entry, [field]: 0 }), {}),
      );
    }
    const bucket = buckets.get(bucketKey);
    valueFields.forEach((field) => {
      const numericValue = Number(chartData[field]?.[index]);
      bucket[field] += Number.isFinite(numericValue) ? numericValue : 0;
    });
  });

  const labels = Array.from(buckets.keys()).sort();
  return {
    ...chartData,
    labels,
    ...valueFields.reduce(
      (result, field) => ({
        ...result,
        [field]: labels.map((label) => buckets.get(label)?.[field] || 0),
      }),
      {},
    ),
    granularity,
  };
};

export const formatDashboardChartGranularity = (granularity) => {
  if (granularity === DASHBOARD_CHART_GRANULARITY.MONTH) return "Par mois";
  if (granularity === DASHBOARD_CHART_GRANULARITY.WEEK) return "Par semaine";
  return "Par jour";
};
